import { frontendURL } from '../../../helper/URLHelper';
import { routes as inicioRoutes } from '../laisDashboard/routes';
import * as doneVisitsRoute from './doneVisits.route';
import * as negotiationRoute from './offer.route';
import * as offersRoute from './offers.route';
import * as saleOfferRoute from './saleOffer.route';
import * as documentationRoute from './documentation.route';
import * as contractRoute from './contract.route';
import * as agendaRoute from './agenda.route';
import * as agendaVisitDetailRoute from './agendaVisitDetail.route';
import * as entryInformationRoute from './entryInformation.route';
import * as entryInformationResultListRoute from './entryInformationResultList.route';
import * as timeBlockRoute from './timeBlock.route';
import * as clientProfileRoute from './clientProfile.route';
import * as visitorInfoRoute from './visitorInfo.route';
import * as myClientsGroupedRoute from './myClientsGrouped.route';
import * as ongoingNegotiationRoute from './ongoingNegotiation.route';
import * as getKeysRoute from './getKeys.route';
import * as agentKeysRoute from './agentKeys.route';
import * as scheduledVisitsRoute from './scheduledVisits.route';
import * as buyerReferralRoute from './buyerReferral.route';
import * as searchClientsRoute from './searchClients.route';
import * as onlineSupportRoute from './onlineSupport.route';
import * as clientsCrmRoute from './clientsCrm.route';
import * as myActivityRoute from './myActivity.route';
import * as ambassadorConsentTermRoute from './ambassadorConsentTerm.route';

export const REFERENCE_AUTHENTICATED_ROUTE_META = Object.freeze({
  referenceAuthenticated: true,
});

export const REFERENCE_ROOT_ROUTE_META = Object.freeze({
  ...REFERENCE_AUTHENTICATED_ROUTE_META,
  referenceRoot: true,
});

const getRouteRecords = routeModule => {
  const routeRecords =
    routeModule.routes || routeModule.route || routeModule.default;

  return (Array.isArray(routeRecords) ? routeRecords : [routeRecords]).filter(
    Boolean
  );
};

const referenceAccountPath = frontendURL('accounts/:accountId');

const normalizeReferencePath = path => {
  if (path === referenceAccountPath || path.startsWith(referenceAccountPath)) {
    return path;
  }

  return frontendURL(`accounts/:accountId/${String(path).replace(/^\/+/, '')}`);
};

const createReferenceRoute = ({ path, component }) => ({
  path: normalizeReferencePath(path),
  component,
  meta: { ...REFERENCE_AUTHENTICATED_ROUTE_META },
});

const referenceRouteModules = [
  doneVisitsRoute,
  negotiationRoute,
  offersRoute,
  saleOfferRoute,
  documentationRoute,
  contractRoute,
  agendaRoute,
  agendaVisitDetailRoute,
  entryInformationRoute,
  entryInformationResultListRoute,
  timeBlockRoute,
  clientProfileRoute,
  visitorInfoRoute,
  myClientsGroupedRoute,
  ongoingNegotiationRoute,
  getKeysRoute,
  agentKeysRoute,
  scheduledVisitsRoute,
  buyerReferralRoute,
  searchClientsRoute,
  onlineSupportRoute,
  clientsCrmRoute,
  myActivityRoute,
  ambassadorConsentTermRoute,
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId'),
    component: inicioRoutes[0].component,
    meta: { ...REFERENCE_ROOT_ROUTE_META },
  },
  ...referenceRouteModules.flatMap(getRouteRecords).map(createReferenceRoute),
];

export default routes;
